module.exports = __webpack_public_path__ + "static/media/pattern-5.49833879.png";